export default __webpack_public_path__ + "static/media/ltm2.123ae3d8.webp";